import React from 'react';
import { Box, Flex, Text, Link } from 'rebass/styled-components';
import { Logo } from '@getro/rombo';
import { FindemApplicationContainer } from 'components/organisms/jobsDataTable/components/FindemApplicationContainer';
import { useInitializedWidget } from './hooks/useInitializedWidget';

export const SharedAgent = () => {
  const { isLoading, error } = useInitializedWidget();
  return (
    <>
      <Box
        px="16px"
        py="16px"
        sx={{
          borderBottom: '1px solid',
          borderColor: 'border.subtle',
        }}
      >
        <Flex
          justifyContent="space-between"
          alignItems="center"
          sx={{
            gap: '16px',
          }}
        >
          <Flex sx={{ gap: '16px', alignItems: 'center', flex: 1 }}>
            <Text fontSize="18px" fontWeight="600" color="text.dark" lineHeight="1.4">
              AI Recruiter - Agent shared view configuration
            </Text>
          </Flex>

          {/* Right side: Getro logo */}
          <Flex alignItems="center" sx={{ flexShrink: 0 }}>
            <Link href="https://www.getro.com" target="_blank" rel="noopener noreferrer">
              <Logo color="primary" width="96px" />
            </Link>
          </Flex>
        </Flex>
      </Box>
      <Box
        flex="1"
        sx={{
          position: 'relative',
          overflow: 'hidden',
          height: 'calc(100vh - 120px)',
          iframe: { height: '100%' },
        }}
      >
        <FindemApplicationContainer
          hideHeader
          isLoading={isLoading}
          error={error}
          title="Recruiting agent"
          view="shared-calibration"
        />
      </Box>
    </>
  );
};
